"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextArea = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = require("../Input/index.styles"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var StyledTextArea = /*#__PURE__*/_styledComponents["default"].textarea.withConfig({
  displayName: "indexstyles__StyledTextArea",
  componentId: "sc-1im2t1i-0"
})(["", " height:6.1rem;"], _index.inputStyles);

exports.StyledTextArea = StyledTextArea;